import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

export const WithdrawalBitcoinPopupInfoLabel = ({ label }) => (
  <span className="withdrawal-bitcoin__label">
    <Label message={label} />
    {': '}
  </span>
);

WithdrawalBitcoinPopupInfoLabel.propTypes = {
  label: PropTypes.string.isRequired,
};
